module.exports = __webpack_public_path__ + "img/NO916012683.cff203a8.png";